import React, { useState } from "react";
import cn from "classnames";
import styles from "./Table.module.sass";
import Row from "./Row";

const Table = ({ data, className, activeTable, setActiveTable }) => {
  const [activeId, setActiveId] = useState(data?.[0]?.id);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, { [styles.active]: activeTable })}>
          <div className={styles.col}>Camera Name</div>
          <div className={styles.col}>Camera</div>
          <div className={styles.col}>Created On</div>
        </div>
        {data?.map((camera, index) => (
          <Row
            item={camera}
            key={index}
            activeTable={activeTable}
            setActiveTable={setActiveTable}
            activeId={activeId}
            setActiveId={setActiveId}
            value={selectedFilters.includes(camera.id)}
            onChange={() => handleChange(camera.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;